// extracted by mini-css-extract-plugin
export default {"header":"modal_header__oe722","title":"modal_title__0XpA9","closeBtnContainer":"modal_closeBtnContainer__w0ymK"};